var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlbProtectedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21.678mm",
    height: "21.473mm",
    viewBox: "0 0 21.678 21.473",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24.007 -150.71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25.653 154.7c4.1409-0.73978 7.3092-2.5978 9.5653-3.5861 1.7036 1.0964 4.7415 2.9287 8.8566 3.5288 2.0948 10.625-3.7213 15.416-8.5798 16.883-5.8241-1.331-11.006-5.2147-9.842-16.826z",
    fill: "#5f277e"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.068356)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.049,
    y: 155.68,
    width: 5.7693,
    height: 6.0628,
    rx: 2.3399,
    ry: 3.0314,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.042,
    y: 158.96,
    width: 9.7816,
    height: 7.4821,
    rx: 1.4894,
    ry: 1.4973,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.12231)",
    fill: "#5f277e"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.056,
    cy: 161.95,
    rx: 1.2965,
    ry: 1.2721
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.346,
    y: 162.19,
    width: 1.4189,
    height: 2.6909,
    rx: 0.27286,
    ry: 0.61734
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24.153 -150.67)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25.978 154.6c4.1409-0.73978 6.0652-1.8095 8.2098-3.0207 1.167-0.65906 1.1325-0.61042 2.2358 0.18442 2.2926 1.6516 6.4457 2.6947 7.7547 2.8501 0.17568 0.0208 0.21357 0.82773 0.2591 1.2509 0.76068 7.0705-1.1898 11.93-7.3411 15.107-1.3273 0.68554-2.3824 0.33624-3.4408-0.10709-6.3297-2.6514-8.2754-7.6938-7.9655-14.714 0.01941-0.4396-0.05298-1.5724 0.28785-1.5504z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.117,
    y: 155.68,
    width: 5.7693,
    height: 6.0628,
    rx: 2.3399,
    ry: 3.0314
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.111,
    y: 158.96,
    width: 9.7816,
    height: 7.4821,
    rx: 1.4894,
    ry: 1.4973
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.292,
    y: 162.19,
    width: 1.4189,
    height: 2.6909,
    rx: 0.27286,
    ry: 0.61734
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.316 163.02a1.2965 1.2721 0 0 1-0.56217-1.4256 1.2965 1.2721 0 0 1 1.2394-0.9262 1.2965 1.2721 0 0 1 1.2514 0.91048 1.2965 1.2721 0 0 1-0.54342 1.4325"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlbProtectedIcon);
export default __webpack_public_path__ + "static/media/plb_protected_icon.8052c1443a1a3cdb85119c88aa300015.svg";
export { ForwardRef as ReactComponent };